import { AppService } from './../../service/app.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit, AfterViewInit {
  @ViewChild('landtitle') landtitle: ElementRef;
  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private appService: AppService,
    private titleService: Title) {

    this.titleService.setTitle("Congratulations! - 2026 CAPE Contract Ratification");
  }

  ngOnInit() {
    // log the user out as soon as they get to this page.
    // clicking on the LOG OUT button, IF they click it, will simply take
    // them back to the LOG IN screen. -SKF [Per Ken 7/11/19]
    this.authService.logout().subscribe();
  }
  ngAfterViewInit() {
    this.setFocus();

  }

  logout() {
    // the user/Voter is already logged out at this point.
    this.appService.clearAll();
    this.router.navigate(['/']);
  }
  setFocus() {
    this.landtitle.nativeElement.focus();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/success-page/success-page.component.ts